import React from 'react'
import ShopSubscriptionPricing from '../../components/Subscription/ShopSubscriptionPricing';
import OnboardingSteps from '../../components/Shop/OnboardingSteps';
import useWindowSize from "../../hooks/useWindowSize";
import OnboardingStepsMobile from "../../components/Shop/OnboardingStepsMobile";
import DashboardHeader from '../../components/Shop/Layout/DashboardHeader';
import DashboardSideBar from '../../components/Shop/Layout/DashboardSideBar';

const ShopSubscriptionPage = () => {
  const windowSize = useWindowSize();
  const isMobile = windowSize.width <= 768; 
  return (
    <div className="shop-subscription-page-container">
      <DashboardHeader />
      <div className="shop-subscription-page-content shop-management-layout">
        <aside className="shop-subscription-page-sidebar shop-management-sidebar-slot">
          <DashboardSideBar active={3} />
        </aside>
        <main className="shop-subscription-page-main shop-management-main-panel">
          <section className="shop-subscription-page-card">
            {isMobile ? (
              <OnboardingStepsMobile currentStep={5} />
            ) : (
              <OnboardingSteps currentStep={5} />
            )}
            <ShopSubscriptionPricing />
          </section>
        </main>
      </div>
    </div>
  )
}

export default ShopSubscriptionPage;